define('LazyLoad',['jquery','underscore','IntersectionObserver'],function($,_,IntersectionObserver){
    //
    // tailormade jQuery Lazyload for SushiShop
    //

    var cachedSrc = [],
        supportIntersectionObserver = !!('IntersectionObserver' in window),
        observer,
        config = {
            // If the image gets within 50px in the Y axis, start the download.
            rootMargin: '50px 0px',
            threshold: 0.01
        };

    function InitImage(img,ignoreScroll){
        var $img = $(img),
            imgSrc = $img.attr('src');

        if(!imgSrc){
            if(supportIntersectionObserver){
                observer.observe(img);
            }else{
                PreloadImage(img);
            }
        }

    }

    function onIntersection(entries) {
        // Loop through the entries
        entries.forEach(function(entry) {
                // Are we in viewport?
                if (entry.intersectionRatio > 0) {
                // Stop watching and load the image
                    var target = entry.target;
                    observer.unobserve(target);
                    PreloadImage(target);
            }
        });
    }

    function PreloadImage(img){
        var $img = $(img),
            src = $img.data('src'),
            isCached = _(cachedSrc).contains(src);

        if(isCached){
            $img.addClass('ready cached');
        }else{
            $img.one('load',function(){
                cachedSrc.push(src);
                $img.addClass('ready');
            });
        }
        $img.attr('src',src);

    }

    if(supportIntersectionObserver){
        observer = new IntersectionObserver(onIntersection, config);
    }

    function Load(context,ignoreScroll){
        //
        // test img offset, and load if not ready
        //
        context.each(function(){
            InitImage(this,ignoreScroll);
        })
    }
    return Load
});
